// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2WAjE","title":"Info_title__2SWX0","links":"Info_links__1kYQ1","link":"Info_link__1HC2K","logo":"Info_logo__1yM8B"};